import React, { Component, Fragment } from 'react';
import {
  CloseCircleFilled,
  CloseOutlined,
  DeleteOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { Select, Input, Popover, Tooltip } from "antd";
import { strDelimited } from '../../../../services/helper/split';
import IconCollection from '../../../../components/TreeIconCollection';
import _ from 'lodash';

class ICModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      portList: [],
      maxHeight: 300
    }
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
    this.initData()
    document.addEventListener('mousedown', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, true);
  }

  componentDidUpdate(prevProps) {
    const { selectFileList, pairs } = this.props;
    if (!_.isEqual(selectFileList, prevProps.selectFileList)) {
      const fileInfo = selectFileList[0]
      this.setState({
        selectFile: {
          libraryId: fileInfo ? fileInfo.libraryId : '',
          fileName: fileInfo ? fileInfo.fileName : '',
          modelKey: fileInfo ? fileInfo.modelKey : '',
          subckt: fileInfo ? fileInfo.subckt : '',
          nodes: fileInfo ? fileInfo.nodes : [],
          type: fileInfo ? fileInfo.type : '',
          notes: fileInfo ? fileInfo.notes : []
        }
      })
    }
    if (pairs.length !== prevProps.pairs.length) {
      this.initPortList()
    }
  }


  handleClickOutside = (e) => {
    const { target } = e;
    const PopoverRoot = document.getElementsByClassName('spice-node-select-Popover')[0];
    const selectRoot = document.getElementsByClassName('nodes-list-file-dropdown')[0];

    if (!PopoverRoot) {
      return;
    }

    if (!PopoverRoot || (PopoverRoot && !PopoverRoot.contains(target) && (!selectRoot || !selectRoot.contains(target)))) {
      this.closeNodesSelection();
    }
  }

  initData = () => {
    const { selectFileList } = this.props
    if (selectFileList.length) {
      const fileInfo = selectFileList[0]
      this.setState({
        selectFile: {
          libraryId: fileInfo ? fileInfo.libraryId : '',
          fileName: fileInfo ? fileInfo.fileName : '',
          modelKey: fileInfo ? fileInfo.modelKey : '',
          subckt: fileInfo ? fileInfo.subckt : '',
          nodes: fileInfo ? fileInfo.nodes : [],
          type: fileInfo ? fileInfo.type : ''
        }
      })
    }
    this.initPortList()
  }

  initPortList = () => {
    const { portList, pairs } = this.props
    const pairsMap = new Map(pairs.map(pair => {
      const key = `${pair.designId}-${pair.powerNet}-${pair.port}`;
      return [key, pair];
    }));
    const rightPorts = pairs.filter(port => port.type === 'right');
    const _portList = portList.map(port => ({
      ...port,
      ...(pairsMap.get(`${port.designId}-${port.powerNet}-${port.port}`) || {})
    }));
    this.setState({
      portList: [..._portList, ...rightPorts]
    })
  }

  closeNodesSelection = () => {
    this.setState({
      editNode: null,
      editType: null,
      searchValue: null,
      editComp: null
    })
  }

  selectNodesFile = (keyObj) => {
    const { selectFileList } = this.props;
    if (!keyObj) {
      this.setState({
        selectFile: {}
      })
      return;
    }
    const [libraryId, modelKey, subckt] = strDelimited(keyObj.key, "::");
    if (!libraryId || !modelKey) {
      this.setState({
        selectFile: {}
      })
      return;
    }
    const fileInfo = selectFileList.find(item => item.libraryId === libraryId);
    this.setState({
      selectFile: {
        libraryId,
        fileName: fileInfo ? fileInfo.fileName : '',
        modelKey,
        subckt,
        nodes: fileInfo ? fileInfo.nodes : [],
        type: fileInfo ? fileInfo.type : '',
        notes: fileInfo ? fileInfo.notes : []
      }
    })
  }

  openSelectNode = ({ e, port, value, currentItem }) => {
    const { selectFile } = this.state
    const { selectFileList } = this.props
    const editDesignId = currentItem.designId
    const editPort = port
    const editNode = `${editDesignId}-${editPort}`
    const libraryId = currentItem.libraryId || ""
    const modelKey = currentItem.modelKey || ""
    const subckt = currentItem.subckt || ""
    let _selectFile = selectFile || {}
    if (libraryId) {
      const file = selectFileList.find(item => item.libraryId === libraryId && item.modelKey === modelKey)
      _selectFile = {
        libraryId,
        fileName: file ? file.fileName : "",
        subckt,
        modelKey,
        type: file ? file.type : "",
        nodes: file ? file.nodes : [],
        notes: file ? file.notes : []
      };
    }
    let top = 300;
    if (e && e.target) {
      const rect = e.target.getBoundingClientRect();
      top = rect ? rect.top || 300 : 300;
    }
    this.setState({
      editNode,
      searchValue: value && value.length ? value[0] : '',
      selectFile: _selectFile,
      maxHeight: top - 30 > 300 ? top - 30 : 300
    })
  }

  stopPropagation = (e) => {
    e.stopPropagation();
  }

  selectPinNode = ({ node, selectFile, currentItem }) => {
    const { portList } = this.state
    const { pairs } = this.props
    let _portList = JSON.parse(JSON.stringify(portList))
    let _pairs = JSON.parse(JSON.stringify(pairs))
    const subckt = selectFile.subckt, libraryId = selectFile.libraryId, modelKey = selectFile.modelKey, fileName = selectFile.fileName
    const index = _portList.findIndex(item => {
      return item.designId === currentItem.designId && item.port === currentItem.port && item.powerNet === currentItem.powerNet
    })
    if (index > -1) {
      if (_portList[index].nodes.includes(node)) {
        _portList[index].nodes = _portList[index].nodes.filter(n => n !== node)
      } else {
        _portList[index].nodes.push(node)
      }
      _portList[index].fileName = fileName
      _portList[index].libraryId = libraryId
      _portList[index].modelKey = modelKey
      _portList[index].subckt = subckt ? subckt : "";
      const dieIndex = _portList.findIndex(item => item.nodes.includes(node) && item.type === 'right');
      if (_portList[index].type === 'left' && dieIndex > -1) {
        _portList[dieIndex].nodes = _portList[dieIndex].nodes.filter(n => n !== node);
        if (!_portList[dieIndex].nodes.length) {
          _portList.splice(dieIndex, 1)
        }
      }
    }
    const pairIndex = _pairs.findIndex(item => item.port === currentItem.port && item.designId === currentItem.designId && item.powerNet === currentItem.powerNet)
    if (pairIndex > -1) {
      if (_pairs[pairIndex].nodes.includes(node)) {
        _pairs[pairIndex].nodes = _pairs[pairIndex].nodes.filter(n => n !== node)
      } else {
        _pairs[pairIndex].nodes.push(node)
      }
      _pairs[pairIndex].subckt = subckt ? subckt : ""
      _pairs[pairIndex].libraryId = libraryId
      _pairs[pairIndex].modelKey = modelKey
      const dieIndex = _pairs.findIndex(item => item.nodes.includes(node) && item.type === 'right');
      if (_pairs[index].type === 'left' && dieIndex > -1) {
        _pairs[dieIndex].nodes = _pairs[dieIndex].nodes.filter(n => n !== node);
        if (!_pairs[dieIndex].nodes.length) {
          _pairs.splice(dieIndex, 1)
        }
      }
    }
    this.props.updatePairs(_pairs)
    this.setState({
      portList: _portList
    })
  }

  deleteSelectNode = (e, type, currentItem) => {
    e && e.stopPropagation()
    const { portList } = this.state
    const { pairs } = this.props
    let _portList = JSON.parse(JSON.stringify(portList))
    let _pairs = JSON.parse(JSON.stringify(pairs))
    const index = _portList.findIndex(item => {
      return item.designId === currentItem.designId && item.port === currentItem.port && item.powerNet === currentItem.powerNet
    })
    if (index > -1) {
      _portList[index].nodes = []
      _portList[index].fileName = ""
      _portList[index].libraryId = ""
      _portList[index].modelKey = ""
      _portList[index].subckt = ""
    }
    const pairIndex = _pairs.findIndex(item => item.port === currentItem.port && item.designId === currentItem.designId && item.powerNet === currentItem.powerNet)
    if (pairIndex > -1) {
      _pairs[pairIndex].nodes = []
      _pairs[pairIndex].subckt = ""
      _pairs[pairIndex].libraryId = ""
      _pairs[pairIndex].modelKey = ""
    }
    this.props.updatePairs(_pairs)
    this.setState({
      portList: _portList
    })
  }

  isSameNode = (port, selectFile, node) => {
    return (
      port.libraryId === selectFile.libraryId &&
      port.subckt === selectFile.subckt &&
      port.modelKey === selectFile.modelKey &&
      port.nodes.includes(node)
    );
  }

  getDisplayPortList = ({ currentItem, searchValue, selectFile }) => {
    const { portList } = this.state;
    const { nodes = [], notes = [] } = selectFile;
    const nodeList = nodes.map(node => {
      let select = false;
      let currentSelect = false;
      if (this.isSameNode(currentItem, selectFile, node)) {
        currentSelect = true;
      }
      select = portList.some(port =>
        (port && port.type === 'left' && port !== currentItem && this.isSameNode(port, selectFile, node))
      );
      const notePort = notes.find(item => item.port === node);
      let note = notePort ? notePort.info : node
      return { node, select, currentSelect, note };
    });

    const current = nodeList.filter(item => item.currentSelect);
    const matched = nodeList.filter(item => item.node.includes(searchValue) && !item.currentSelect && !item.select);
    const unused = nodeList.filter(item => !item.select && !item.currentSelect && !item.node.includes(searchValue));
    const used = nodeList.filter(item => item.select && !item.currentSelect);

    return [...current, ...matched, ...unused, ...used];
  }

  searchNode = (e) => {
    this.setState({
      searchValue: e.target.value
    })
  }

  cleanPort = () => {
    const { portList } = this.state
    const { pairs } = this.props
    let _portList = JSON.parse(JSON.stringify(portList))
    let _pairs = JSON.parse(JSON.stringify(pairs))
    _portList = _portList.map(item => {
      return {
        ...item,
        nodes: [],
        subckt: "",
        libraryId: "",
        modelKey: "",
        fileName: ""
      }
    })
    _pairs = _pairs.map(item => {
      return {
        ...item,
        nodes: [],
        subckt: "",
        libraryId: "",
        modelKey: "",
        fileName: ""
      }
    })
    this.props.updatePairs(_pairs)
    this.setState({
      portList: _portList
    })
  }

  addNewRightPort = (e, net) => {
    e && e.stopPropagation();
    const { portList } = this.state
    const { pairs } = this.props
    let _portList = JSON.parse(JSON.stringify(portList))
    let _pairs = JSON.parse(JSON.stringify(pairs))
    const rightPorts = portList.filter(port => port.type === 'right');
    let portIndex = rightPorts.length + 1;
    const isPortIndexUsed = (index) => rightPorts.some(port => port.port === `die_${index}`);
    while (isPortIndexUsed(portIndex)) {
      portIndex = portIndex + 1;
    }
    const designId = portList && portList.length ? portList[0].designId : 'die'
    _portList.push({
      port: `die_${portIndex}`,
      portName: `die_${portIndex}`,
      powerNet: net,
      designId: designId,
      nodes: [],
      subckt: "",
      libraryId: "",
      modelKey: "",
      type: 'right'
    })
    _pairs.push({
      port: `die_${portIndex}`,
      portName: `die_${portIndex}`,
      powerNet: net,
      designId: designId,
      nodes: [],
      subckt: "",
      libraryId: "",
      modelKey: "",
      type: 'right'
    })
    this.props.updatePairs(_pairs)
    this.setState({
      portList: _portList
    })
  }

  setRemainAsDie = (e, net) => {
    e && e.stopPropagation();
    const { portList } = this.state
    const { pairs, selectFileList } = this.props
    let _portList = portList.filter(port => port.type === 'left' || port.powerNet !== net)
    let _pairs = pairs.filter(port => port.type === 'left' || port.powerNet !== net)
    const leftPorts = _portList.filter(port => port.type === 'left');
    const designId = portList && portList.length ? portList[0].designId : 'die';

    const fileInfos = _portList.map(port => ({ libraryId: port.libraryId, modelKey: port.modelKey }));
    let nodeList = [], exsit = []
    for (let file of selectFileList) {
      const { nodes = [], libraryId, modelKey } = file;
      if (!exsit.includes(`${libraryId}-${modelKey}`) && fileInfos.some(file => file.libraryId === libraryId && file.modelKey === modelKey)) {
        nodeList.push(...nodes.map(node => {
          let select = false;
          select = leftPorts.some(port =>
            (port && this.isSameNode(port, file, node))
          );
          return { node, select, ...file };
        }).filter(node => !node.select))
      }
    }
    const rightPorts = nodeList.map((node, index) => {
      return {
        port: `die_${index + 1}`,
        portName: `die_${index + 1}`,
        powerNet: net,
        designId: designId,
        nodes: [node.node],
        subckt: node.subckt,
        libraryId: node.libraryId,
        modelKey: node.modelKey,
        fileName: node.fileName,
        type: 'right'
      }
    })

    this.props.updatePairs([..._pairs, ...rightPorts])
    this.setState({
      portList: [..._portList, ...rightPorts]
    })
  }

  removeDiePort = (e, currentItem) => {
    e && e.stopPropagation()
    const { portList } = this.state
    const { pairs } = this.props
    let _portList = JSON.parse(JSON.stringify(portList))
    let _pairs = JSON.parse(JSON.stringify(pairs))
    _portList = _portList.filter(item => { return item.designId === currentItem.designId && item.port === currentItem.port && item.powerNet === currentItem.powerNet ? false : true })
    _pairs = _pairs.filter(item => { return item.port === currentItem.port && item.designId === currentItem.designId && item.powerNet === currentItem.powerNet ? false : true })
    this.props.updatePairs(_pairs)
    this.setState({
      portList: _portList
    })
  }

  removeDies = () => {
    const { portList } = this.state
    const { pairs } = this.props
    let _portList = JSON.parse(JSON.stringify(portList))
    let _pairs = JSON.parse(JSON.stringify(pairs))
    _portList = _portList.filter(item => item.type !== 'right')
    _pairs = _pairs.filter(item => item.type !== 'right')
    this.props.updatePairs(_pairs)
    this.setState({
      portList: _portList
    })
  }

  autoSetPorts = (fileInfo) => {
    const { portList } = this.state
    const { pairs, portList: propsPortList } = this.props
    const { subckt, nodes, libraryId, fileName, modelKey, notes = [] } = fileInfo;
    let _portList = portList.filter(item => item.type === 'left');
    let _pairs = pairs.filter(item => item.type === 'left');

    let exsitPorts = [];
    let nodeInfos = notes.length ? notes : nodes.map(item => ({ node: item, info: item }));
    _portList.forEach(port => {
      let number = 0;
      const portIndex = propsPortList.find(item => item.port === port.port && item.designId === port.designId && item.powerNet === port.powerNet);
      const pins = portIndex > -1 ? propsPortList[portIndex].pins || [] : [];

      let netNodeInfos = nodeInfos.filter(node => node.info.toLowerCase().includes(port.powerNet.toLowerCase()));
      if (netNodeInfos.length) {
        number = number + 1
      } else {
        netNodeInfos = nodeInfos
      }

      const [comp, ...suffix] = port.port.split('_');
      let compNodeInfos = netNodeInfos.filter(node => node.info.includes(comp));
      if (compNodeInfos.length) {
        number = number + 1
      } else {
        netNodeInfos = nodeInfos
      }

      let pinNodeInfos = compNodeInfos.filter(node => pins.some(pin => node.info.includes(pin)));
      if (pinNodeInfos.length) {
        number = number + 1
      } else {
        pinNodeInfos = compNodeInfos
      }

      if (number >= 2) {
        const nodes = pinNodeInfos.map(node => node.node);
        exsitPorts.push(...nodes)
        nodeInfos = nodeInfos.filter(node => !exsitPorts.includes(node.node));

        port.nodes = nodes;
        port.fileName = fileName
        port.libraryId = libraryId
        port.modelKey = modelKey
        port.subckt = subckt ? subckt : ""

        const pairIndex = _pairs.find(item => item.port === port.port && item.designId === port.designId && item.powerNet === port.powerNet);
        if (pairIndex > -1) {
          _pairs[pairIndex].nodes = nodes
          _pairs[pairIndex].fileName = fileName
          _pairs[pairIndex].libraryId = libraryId
          _pairs[pairIndex].modelKey = modelKey
          _pairs[pairIndex].subckt = subckt ? subckt : ""
        }
      }
    })
    // const unusedNodes = nodes.filter(node => !exsitPorts.includes(node));
    // const designId = portList && portList.length ? portList[0].designId : 'die';
    // const net = _portList[0] ? _portList[0].powerNet : 'powerNet';
    // const rightPorts = unusedNodes.map((node, index) => {
    //   return {
    //     port: `die_${index + 1}`,
    //     portName: `die_${index + 1}`,
    //     powerNet: net,
    //     designId: designId,
    //     nodes: [node],
    //     subckt: subckt || "",
    //     libraryId: libraryId,
    //     modelKey: modelKey,
    //     fileName: fileName,
    //     type: 'right'
    //   }
    // });
    this.props.updatePairs([..._pairs])
    this.setState({
      portList: [..._portList]
    })
  }

  nodeSelectRender = ({ portName, port, type, currentItem }) => {
    const { searchValue, selectFile = {}, maxHeight } = this.state;
    const { selectFileList } = this.props;
    // const currentInfo = modelInfoListIndex > -1 ? modelInfoList[modelInfoListIndex] : null;
    // const _pinList = editType ? currentInfo && currentInfo.modelPinList ? currentInfo.modelPinList : [] : pinList;
    const nodeList = this.getDisplayPortList({ currentItem, searchValue, selectFile });
    // const displayPin = currentItem[`pinNodeDisplay`] ? currentItem[`pinNodeDisplay`] : pin;
    const { libraryId, subckt, fileName, modelKey } = selectFile;
    return (
      <div className='nodes-content' style={{ maxHeight, maxWidth: 400 }}>
        <div className='nodes-content-header'>
          <span className='nodes-content-header-span'> {portName ? portName : `Port ${port}`}</span>
        </div>
        <div className='node-content-close' onClick={() => this.closeNodesSelection()}>
          <CloseOutlined className='node-content-close-icon' />
        </div>
        <div className="node-list-body-with-search">
          <div className="node-list-body-search-wrapper">
            <Select
              placeholder={`Select File/Subckt`}
              className='nodes-list-file-select'
              labelInValue
              value={{
                key: libraryId ? subckt ? `${libraryId}::${modelKey}::${subckt}` : `${libraryId}::${modelKey}` : "",
                label: subckt ? `${fileName}::${subckt}` : fileName || ""
              }}
              popupClassName='nodes-list-file-dropdown'
              popupMatchSelectWidth={false}
              onChange={option => option && this.selectNodesFile({ label: option.label, key: option.value })}
              options={selectFileList.map(item => ({
                value: item.subckt ? `${item.libraryId}::${item.modelKey}::${item.subckt}` : `${item.libraryId}::${item.modelKey}`,
                label: item.subckt ? `${item.fileName}::${item.subckt}` : item.fileName || "",
                title: item.subckt ? `${item.fileName}::${item.subckt}` : item.fileName || "",
                className: 'spice-nodes-content-file'
              }))}
            />
            <Input
              placeholder={`Search`}
              allowClear
              suffix={!searchValue ? <SearchOutlined style={{ color: 'rgba(0, 0, 0, .25)' }} /> : null}
              value={searchValue}
              onChange={(e) => this.searchNode(e)}
            />
            <ul className='node-list-ul' style={{ maxHeight: maxHeight - 100 }}>
              {nodeList.map(item =>
                <li
                  key={item.node}
                  title={item.node}
                  className={item.currentSelect ? 'current-pin-selected-node-li' : (item.select ? 'node-li-selected' : '')}
                  onClick={() => !item.select ? this.selectPinNode({ node: item.node, selectFile, type, currentItem }) : null}
                >
                  {item.note || item.node}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    );
  }

  getLeftPinDisplay = ({ item, editNode }) => {
    const [editDesignId, editPort] = strDelimited(editNode, '-')
    const { port = '', designId = '', portName = '', nodes = [] } = item || {}
    const key = `${designId}-${port}`
    const suffix = nodes && nodes.length && nodes.length > 1 ? `+${nodes.length - 1}` : ""
    const input = nodes && nodes.length ? nodes.length > 1 ? `${nodes[0]}, +${nodes.length - 1}` : nodes[0] : ""
    return (
      <div key={key} className='spice-total-pin-box' style={{ width: 204 }}>
        {port ? <Fragment>
          <div className='spice-pin-die-value-box'>
            {editNode && editDesignId === designId && editPort === port ? <Popover
              classNames={{ root: 'spice-node-select-Popover' }}
              content={this.nodeSelectRender({
                portName: portName,
                port: port,
                type: "leftPort",
                currentItem: item
              })}
              title=""
              trigger="click"
              open={true}
              placement={"top"}
            >
              <Input
                className='spice-pin-input'
                placeholder={'Node'}
                value={input}
                id={port}
                onClick={(e) => this.openSelectNode({
                  port: port,
                  value: nodes,
                  type: "leftPort",
                  currentItem: item,
                  item: item,
                  e
                })}
              />
            </Popover> :
              nodes && nodes.length ?
                <Tooltip
                  classNames={{ root: "aurora-tooltip" }}
                  onClick={(e) => this.stopPropagation(e)}
                  title={<Fragment>{item && item.fileName && <div>FileName:{item.fileName}</div>}<div>Port:{item.nodes.join(', ')}</div></Fragment>}>
                  <div className='spice-pin-input' id={port} title={item.nodes.join(', ')}
                    onClick={(e) => this.openSelectNode({
                      port: port,
                      value: nodes,
                      type: "leftPort",
                      currentItem: item,
                      item: item,
                      e
                    })}
                  >
                    <span style={suffix ? { maxWidth: 55 } : {}}>{nodes[0]}</span>
                    {suffix ? <span style={{ width: 25 }}>, {suffix}</span> : null}
                    <CloseCircleFilled
                      className='spice-pin-node-delete-icon'
                      onClick={(e) => { this.deleteSelectNode(e, "leftPort", item) }}
                    />
                  </div>
                </Tooltip>
                :
                // !item.displayType && 
                <Input
                  className='spice-pin-input'
                  placeholder={'Node'}
                  value={input}
                  id={port}
                  onClick={(e) => this.openSelectNode({
                    port: port,
                    value: nodes,
                    type: "leftPort",
                    currentItem: item,
                    item: item,
                    e
                  })}
                />}
          </div>
          {/* pin_L */}
          <div className='spice-pin-die-box'
            // style={{ width: leftPinWidth + 2 }}
            title={portName ? portName : `Port ${port}`}
          >
            {portName ? portName : `Port ${port}`}
          </div>
          {/* - */}
          <div className='spice-pin-line'></div>
          <div className='spice-pin-circle'></div>
        </Fragment> : null}
      </div>
    )
  }

  getRightPinDisplay = ({ item, editNode }) => {
    const [editDesignId, editPort] = strDelimited(editNode, '-')
    const { port = '', designId = '', portName = '', nodes = [] } = item || {}
    const key = `${designId}-${port}`
    const suffix = nodes && nodes.length && nodes.length > 1 ? `+${nodes.length - 1}` : ""
    const input = nodes && nodes.length ? nodes.length > 1 ? `${nodes[0]}, +${nodes.length - 1}` : nodes[0] : ""
    return (
      <div key={key} className='spice-total-pin-box' style={{ width: 204 }}>
        {port ? <Fragment>
          <div className='spice-pin-circle'></div>
          <div className='spice-pin-line'></div>
          {/* pin R */}
          <div
            className='spice-pin-box'
            // style={{ width: rightPinWidth + 2 }}
            title={portName ? portName : `Port ${port}`}
          >
            {portName ? portName : `Port ${port}`}
            <CloseOutlined onClick={(e) => this.removeDiePort(e, item)} className='spice-pin-box-delete-icon' />
            {/* {pinR.pinDisplay || modelType === PCB ? pinR.pinDisplay : pinR.pin} */}
          </div>
          {/* pin R connect port */}
          <div className='spice-pin-value-box'>
            {editNode && editDesignId === designId && editPort === port ? <Popover
              classNames={{ root: 'spice-node-select-Popover' }}
              content={this.nodeSelectRender({
                portName: portName,
                port: port,
                type: "rightPort",
                currentItem: item
              })}
              title=""
              trigger="click"
              open={true}
              placement={"top"}
            >
              <Input
                className='spice-pin-input'
                placeholder={'Node'}
                value={input}
                id={port}
                onClick={(e) => this.openSelectNode({
                  port: port,
                  value: nodes,
                  type: "rightPort",
                  currentItem: item,
                  item: item,
                  e
                })}
              />
            </Popover> :
              nodes && nodes.length ?
                <Tooltip
                  classNames={{ root: "aurora-tooltip" }}
                  onClick={(e) => this.stopPropagation(e)}
                  title={<Fragment>{item && item.fileName && <div>FileName:{item.fileName}</div>}<div>Port:{nodes.join(', ')}</div></Fragment>}>
                  <div className='spice-pin-input' id={port} title={nodes.join(', ')}
                    onClick={(e) => this.openSelectNode({
                      port: port,
                      value: nodes,
                      type: "rightPort",
                      currentItem: item,
                      item: item,
                      e
                    })}
                  >
                    <span style={suffix ? { maxWidth: 55 } : {}}>{nodes[0]}</span>
                    {suffix ? <span style={{ width: 25 }}>, {suffix}</span> : null}
                    <CloseCircleFilled
                      className='spice-pin-node-delete-icon'
                      onClick={(e) => { this.deleteSelectNode(e, "rightPort", item) }}
                    />
                  </div>
                </Tooltip>
                :
                // !item.displayType && 
                <Input
                  className='spice-pin-input'
                  placeholder={'Node'}
                  value={input}
                  id={port}
                  onClick={(e) => this.openSelectNode({
                    port: port,
                    value: nodes,
                    type: "rightPort",
                    currentItem: item,
                    item: item,
                    e
                  })}
                />
            }
          </div>
        </Fragment> : null}
      </div >
    );
  }

  titleContent = () => {
    return <div className="spice-pin-connect-node-title" style={{ paddingLeft: 20 }}>
      <span className='spice-pin-left-title cascade-spice-pin-left-title'>PCB</span>
      <span className='spice-pin-right-title cascade-spice-pin-right-title'>Die</span>
      <IconCollection icon='trash' trigger='hover' title='Clean' menu={[{ title: 'Remove Die Ports', func: this.removeDies }, { title: 'Reset Model Ports', func: this.cleanPort }]} />
    </div>
  }

  render() {
    const { editNode, portList } = this.state;
    let className = "spice-pin-connect-node-item";

    const signalSelectDisableClassName = '';
    const nets = [...new Set(portList.map(port => port.powerNet))];
    return (
      <Fragment>
        <div className='spice-netlist-model-content'>

          <div className='spice-connect-content'>
            <ul className='spice-pin-list-ul'>
              {this.titleContent()}
              {nets.map((net, index) => {
                const leftPorts = portList.filter(item => item.powerNet === net && item.type === 'left');
                const rightPorts = portList.filter(item => item.powerNet === net && item.type === 'right');
                const maxLength = Math.max(leftPorts.length, rightPorts.length)
                return <div className={`${className}`} key={index} style={{ height: 32 * maxLength + 30, paddingRight: 10 }}>
                  <div className='spice-pin-list-li-left'>
                    {leftPorts.map(item => this.getLeftPinDisplay({ item, editNode }))}
                  </div>
                  {/* net box */}
                  <div
                    className={index === 0 ? `spice-box spice-box-top ${signalSelectDisableClassName}` : (index === (portList.length - 1) ? `spice-box spice-box-bottom ${signalSelectDisableClassName}` : `spice-box ${signalSelectDisableClassName}`)}
                  >
                    <span className='spice-box-net-text'>{net}</span>
                    <span className='spice-box-add-botton-text'>
                      <span onClick={(e) => this.addNewRightPort(e, net)}>Add die</span>/
                      <span onClick={(e) => this.setRemainAsDie(e, net)}>Set remaining as die</span>
                    </span>
                  </div>
                  <div className='spice-pin-list-li-right'>
                    {rightPorts.length ? rightPorts.map(item => this.getRightPinDisplay({ item, editNode })) : this.getRightPinDisplay({ item: {}, editNode })}
                  </div>
                </div>
              })}
            </ul>
          </div>
        </div>
      </Fragment >
    );
  }
}

export default ICModel;